import {
  IN_SEASON,
  BASE_LAYERS,
  HARVEST,
  CROP_WATER,
  FHA,
  FIELD_SUMMARY,
  IMPORTED_SHAPEFILE,
  OTHER_IMAGERY,
  PLANTING,
  SOIL_TESTS,
  PRESCRIPTION_TYPES,
  WEATHER,
  PRECISION_PLANTING_SUB_LAYERS,
  FHA_KEY,
} from './mapLayerIds';

/*
  The layer names used on the analytics workflow are different than the ones we use internally.
  This constant is used to map our layer names into the analytics layer name when
  tracking analytics events.
*/
export const ANALYTICS_LAYER_IDS = {
  [BASE_LAYERS.PLANTER_ELEVATION]: 'planter_elevation',
  [BASE_LAYERS.COMBINE_ELEVATION]: 'combine_elevation',
  [BASE_LAYERS.OIL_SSURGO]: 'soil_ssurgo',
  [FHA_KEY]: 'field_health_scouting',
  [FHA.SCOUTING]: 'field_health_scouting',
  [FHA.TRUE_COLOR]: 'field_health_true_color',
  [FHA.VEGETATION]: 'field_health_vegetation',
  [PLANTING.PLANTER_SPEED]: 'planter_speed',
  [PLANTING.DATE]: 'planting_date',
  [PLANTING.HYBRID]: 'planting_hybrid',
  [PLANTING.POPULATION]: 'planting_population',
  [HARVEST.YIELD]: 'yield',
  [HARVEST.MOISTURE]: 'harvest_moisture',
  [HARVEST.DATE]: 'harvest_date',
  [HARVEST.COMBINE_SPEED]: 'combine_speed',
  [PRESCRIPTION_TYPES.FERTILITY]: 'prescriptions_fertility',
  [PRESCRIPTION_TYPES.PLANTING]: 'prescriptions_planting',
  [IN_SEASON.APPLICATIONS]: 'application_rate',
  [CROP_WATER]: 'crop_water_use',
  [FIELD_SUMMARY]: 'field_summary',
  [IMPORTED_SHAPEFILE]: 'imported_map',
  [OTHER_IMAGERY]: 'other_imagery',
  [SOIL_TESTS]: 'soil_sample',
  [WEATHER]: 'weather',
  [PRECISION_PLANTING_SUB_LAYERS.APPLIED_DOWN_FORCE]: 'applied_downforce',
  [PRECISION_PLANTING_SUB_LAYERS.CLEAN_FURROW]: 'clean_furrow',
  [PRECISION_PLANTING_SUB_LAYERS.DOWN_FORCE]: 'downforce',
  [PRECISION_PLANTING_SUB_LAYERS.FURROW_MOISTURE]: 'furrow_moisture',
  [PRECISION_PLANTING_SUB_LAYERS.ORGANIC_MATTER]: 'organic_matter',
  [PRECISION_PLANTING_SUB_LAYERS.SINGULATION]: 'singulation',
  [PRECISION_PLANTING_SUB_LAYERS.SOIL_TEMPERATURE]: 'soil_temperature',
  [PRECISION_PLANTING_SUB_LAYERS.SPACING]: 'spacing',
  [PRECISION_PLANTING_SUB_LAYERS.UNIFORM_FURROW]: 'uniform_furrow',
};
